import { render } from "./WaveDetailsPanel.vue?vue&type=template&id=4f683fa5&scoped=true"
import script from "./WaveDetailsPanel.vue?vue&type=script&lang=js"
export * from "./WaveDetailsPanel.vue?vue&type=script&lang=js"

import "./WaveDetailsPanel.vue?vue&type=style&index=0&id=4f683fa5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f683fa5"]])

export default __exports__